import { IAsideItem } from '@qima-labs/app/pages/main/shared/components/aside/shared/models/interfaces/aside-item.interface';
import { EQimaIconName } from '@qima/ngx-qima';

export const MENU_ITEMS_COMMON: IAsideItem[] = [
  {
    id: 'to-do-list',
    label: 'APP_ASIDE.COMMON_ITEMS.TODOLIST',
    iconName: EQimaIconName.ASSIGNMENTS,
    matchPath: '/to-do-list',
    path: '/to-do-list',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.TODOLIST',
    permissionKey: 'TODOLIST:VIEW',
    visible: false,
  },
  {
    id: 'dashboard',
    label: 'APP_ASIDE.COMMON_ITEMS.DASHBOARD',
    iconName: EQimaIconName.ANALYTICS,
    matchPath: '/dashboard',
    path: '/dashboard',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.DASHBOARD',
    permissionKey: 'DASHBOARD:VIEW',
    visible: true,
  },
  {
    id: 'report-preparation',
    label: 'APP_ASIDE.COMMON_ITEMS.TEST_ASSIGNMENT',
    iconName: EQimaIconName.LAB_TEST,
    matchPath: '/report-preparation',
    path: '/report-preparation',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.TEST_ASSIGNMENT',
    permissionKey: 'TA:VIEW',
    visible: true,
  },
  {
    id: 'report-generation',
    label: 'APP_ASIDE.COMMON_ITEMS.REPORT_GENERATION',
    iconName: EQimaIconName.REPORTS,
    matchPath: '/report-generation',
    path: '/report-generation',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.REPORT_GENERATION',
    permissionKey: 'REPORTGENERATION:VIEW',
    visible: true,
  },
  {
    id: 'template',
    label: 'APP_ASIDE.COMMON_ITEMS.TEMPLATE',
    iconName: EQimaIconName.CHECKLIST,
    matchPath: '/template',
    path: '/template',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.TEMPLATE',
    permissionKey: 'TEMPLATE:VIEW',
    visible: true,
  },
  {
    id: 'test-set-up',
    label: 'APP_ASIDE.COMMON_ITEMS.TEST_SETUP',
    iconName: EQimaIconName.STANDARD,
    matchPath: '/test-set-up',
    path: '/test-set-up',
    tooltip: 'APP_ASIDE.COMMON_ITEMS.TEST_SETUP',
    permissionKey: 'TESTSETUP:VIEW',
    visible: true,
  },
];
